var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSuccessPuzzle = function SvgSuccessPuzzle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M21.914.572a7.448 7.448 0 0 1 7.448 7.447 7.398 7.398 0 0 1-1.009 3.724h14.663v14.663a7.397 7.397 0 0 1 3.724-1.009 7.448 7.448 0 1 1 0 14.896 7.398 7.398 0 0 1-3.724-1.009v14.663H27.461a7.417 7.417 0 0 0 1.9-4.965 7.448 7.448 0 1 0-14.894 0c0 1.908.72 3.647 1.9 4.965H.812V38.392a7.417 7.417 0 0 0 4.966 1.9 7.448 7.448 0 1 0 0-14.895c-1.909 0-3.648.72-4.965 1.901V11.743h14.662a7.398 7.398 0 0 1-1.008-3.724A7.448 7.448 0 0 1 21.914.572Z",
    fill: "#37CC33",
    fillOpacity: 0.2,
    stroke: "#37CC33",
    strokeWidth: 2
  })));
};
export default SvgSuccessPuzzle;